export const applicationHero = {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/cd6bc0ca-dd75-4ff5-8151-39bf1af3fc4f.jpg',
  alt: 'A heavy wooden door to a private members’ club held ajar at night, firelight spilling onto the stone steps',
  title: 'Some doors are never listed. Only opened.',
  line: 'A few members a year. Reviewed in person. Kept in confidence.',
};

// What membership opens — told as privileges, not features
export const privileges = [
  {
    title: 'Homes never listed',
    text: 'Seen by members first. Often only.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ee27a00a-608b-4c4d-bf92-28b34626a7c2.jpg',
    alt: 'A contemporary cliffside villa with an infinity pool above the sea at sunset',
  },
  {
    title: 'Wheels up in four hours',
    text: 'Jet, yacht and car — one call.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/19d08ad4-119a-4e9e-a291-21be36a9e686.jpg',
    alt: 'A grand tourer on a marina quay beside a superyacht, a private jet in the sky above',
  },
  {
    title: 'Nights never photographed',
    text: 'Venturist and the private series.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/1035e490-4d04-41a5-ba97-aeb9b32614fd.jpg',
    alt: 'A candlelit black-tie dinner on a cliffside terrace above the Riviera at night',
  },
  {
    title: 'Retreats for one household',
    text: 'Closed to everyone else.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/06a12496-41e3-464f-bdde-19c68a4b548e.jpg',
    alt: 'A minimalist retreat pavilion with a steaming stone bath overlooking a misty valley',
  },
];

export const applicationSteps = [
  { title: 'Your application', text: 'Read by a founding partner only. Never shared, never stored beyond its purpose.' },
  { title: 'A private conversation', text: 'Within 72 hours, a call at a time of your choosing — to understand how you live.' },
  { title: 'Your introduction', text: 'If membership is extended, your partner introduces themselves. Quietly, and only once.' },
];

export const residenceCities = [
  'Dubai',
  'Monaco',
  'Hamburg',
  'Mallorca',
  'Ibiza',
  'Menorca',
  'Warsaw',
  'London',
  'Paris',
  'Geneva',
  'Zurich',
  'Milan',
  'New York',
  'Abu Dhabi',
  'Riyadh',
  'Singapore',
  'Hong Kong',
];

export const applicationInterests = [
  'Residences',
  'Private aviation',
  'Yachts',
  'Cars & chauffeurs',
  'Retreats',
  'Restaurant tables',
  'Private events',
  'SL Club',
  'Security & discretion',
  'Image & press',
];

export const referralOptions = ['An existing member', 'A partner of the house', 'A private event', 'The press', 'Other'];

export const applicationLetter = {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/c869f1a9-2f61-429a-bbb6-1f254a59b3f2.jpg',
  alt: 'A cream envelope sealed with black wax on a walnut desk beside a fountain pen, in warm lamplight',
};
